
import Vue from 'vue'
import { mapState, mapActions } from "vuex";
import { TRUCK_SHORTCUT } from "@/consts";

import RouteTruckView from "@/components/truck/RouteTruckView.vue";
import TrucksActions from "@/components/truck/TrucksActions.vue";
import Component from 'vue-class-component';
import TruckModule from '@/store/modules/truck'
import { getModule } from 'vuex-module-decorators';
import permissions from '@/security/permissions';
import { DriverResource } from '../models/api/drivers/get';
import { UpdateTruckDetailSequenceRequest, DetailSequence } from '../models/api/trucks/updateDetailSequence'
import notifications from "../lib/notifications";
import { defaultFilters } from '@/store/modules/truck/helpers';
const truckModuleState = getModule(TruckModule)

@Component({
  components: {
    RouteTruckView,
    TrucksActions
  }
})
export default class TruckDetail extends Vue  {
  $refs!:{
    routeTruckView: RouteTruckView
  }

  shortcuts: any = TRUCK_SHORTCUT
  error: boolean = null
  loading: boolean = true
  errorMessage: string = null
  drivers: DriverResource[] = []
  saving: boolean = false

  get hasError() {
    return !this.loading && this.error
  }

  get truck() {
    return truckModuleState.currentTruck
  }

  async created() {
    let truckId = this.$route.params.idx;

    if(!this.hasPermission(permissions.truck.view.detail))
    {
      this.errorMessage = "You do not have permission to view truck details."
      this.error = true
      this.loading = false
      return
    }
    try {
      await truckModuleState.loadTruck(+truckId);
    } catch (ex) {
      this.error = true;
      if (ex.response.data && ex.response.data.message)
        this.errorMessage = ex.response.data.message;
      else
        this.errorMessage = "Please ensure the truck exists and try again."

    }

    this.loading = false;
  }
};
